var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.sections),function(section,key){return _c(section.section,{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:(-400),expression:"-400"}],key:key,ref:_vm.getContainerRef(section.id),refInFor:true,tag:"component",attrs:{"content":section.content,"tracking":section.tracking,"id":section.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7b14a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 